import NewHealthRecordForm from './NewHealthRecordForm';
import {RECORD} from '../../constants'




export const RecordsUpload = () => {

   
return (
<>

<NewHealthRecordForm

    record_url = {RECORD}

/>
 
</>
)};
